/**
 * fetchWithRetry — fetch with automatic retry and exponential backoff.
 *
 * @param {string} url
 * @param {RequestInit} [options]
 * @param {{ maxAttempts?: number, baseDelay?: number }} [retryOpts]
 * @returns {Promise<any>} Parsed JSON response
 */
export default async function fetchWithRetry(url, options = {}, { maxAttempts = 3, baseDelay = 800 } = {}) {
    let lastError;
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            const res = await fetch(url, options);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        } catch (err) {
            lastError = err;
            if (attempt < maxAttempts) {
                await new Promise((r) => setTimeout(r, baseDelay * attempt));
            }
        }
    }
    throw lastError;
}
